<div class="container-fluid" *ngIf="!isPrograForm">
  <div class="row">
    <div class="col-12 mb-3">
      <div class="page-title-box">
        <div class="page-title-right">
          <a style="cursor: pointer;" class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h3 class="page-title">Organizaciones | Aspirantes | {{nom_ambito}} | Cupos Total <span class="badge bg-primary">{{ cupos }}</span></h3>
        <hr class="text-dark">
      </div>
    </div>
    <div class="col-12 mb-3 text-center">
      <h5>Organizaciones Seleccionadas</h5>
    </div>
  </div>

  <div class="col-12">
    <div class="accordion" id="desplegaOrganizacion">
      <ng-container *ngFor="let org of organizaciones; let x = index;">
        <div class="accordion-item">
          <h2 class="accordion-header" id="heading{{x}}">
            <button class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    attr.data-bs-target="#panel{{x}}"
                    aria-expanded="false"
                    attr.aria-controls="panel{{x}}">
              {{org.organizacion}} | Cupos disponibles &nbsp;&nbsp;<span class="badge bg-primary"> {{org.cupoValue}}</span>
            </button>
          </h2>
          <div id="panel{{x}}" class="accordion-collapse collapse" attr.aria-labelledby="heading{{x}}">
            <div class="accordion-body relacion-container">
              <form id="formularioPerfiles_{{x}}" class="relacion-form-scrollable">
                <div class="row">
                  <div class="col-md-12">
                    <input
                      class="form-control"
                      type="text"
                      id="buscar_estudiante_{{x}}"
                      placeholder="Buscar estudiante"
                      [(ngModel)]="org.searchTermEst"
                      name="buscarEstudiante_{{x}}"
                      (input)="buscarEstudiantes(x)">
                  </div>
                  <div class="col-12" style="margin-top: 10px;" *ngFor="let est of org.filteredEstudiante; let i=index; trackBy: trackByEstId">
                    <div class="form-check" style="padding-left: 2.5rem;">
                      <input class="form-check-input"
                             type="checkbox"
                             id="estudiante_{{est.id_estudiante}}_{{x}}"
                             value="{{est.id_estudiante}}"
                             name="estudiante_{{org.id_organizacion}}"
                             [checked]="est.isChecked"
                             (change)="onCheckboxChange(x, est, $event, org.cupoValue)"
                             [disabled]="est.isChecked && !isEstudianteInOrg(est.id_estudiante, org.id_organizacion)"
                             style="font-size: 20px; border: 3px solid #313131;">
                      <label class="form-check-label" for="estudiante_{{est.id_estudiante}}_{{x}}">{{i+1}} - {{est.nombre_full}}</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="row mt-3">
        <div class="col-md-12 text-center">
          <a style="cursor: pointer;" class="btn btn-lg btn-primary" (click)="procesarSeleccion()">Aceptar</a>
        </div>
      </div>
    </div>
  </div>
</div>

<app-programacion-form *ngIf="isPrograForm"
[year]="year"
[user]="user"
[idOrg]="organizaciones"
[cupo_org]="cupos"
[nomOrganizacion]="nomOrganizacion"
[idMetaRegional]="idMetaRegional"
[id_ambito]="id_ambito"
[estudiante_organizacion]="datosSeleccionadosPorOrganizacion"
(vuelve)="volver_programa($event)"
></app-programacion-form>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
